<template>
    <span>
        <dashboardaluno></dashboardaluno>
    </span>
</template>

<script>
import Dashboardaluno from '@/components/Dashboard-Aluno';

export default {
    name: 'caddashboardaluno',
    components: {
        Dashboardaluno
    }
};
</script>